import React, { useState } from 'react';
import { api } from 'src/api';
import { i18n } from '@lt/localization';
import styles from './invalidTokenForm.module.css';

import { Title } from '../Title';
import type { SetFormType } from '../../types';
import { TokenType, AuthFormType } from '../../types';
import { Content } from '../Content';
import { EmailButton } from '../EmailButton';
import { ButtonWithLoader } from '../ButtonWithLoader/ButtonWithLoader';

interface Props {
  setFormType: SetFormType;
  tokenType: string;
  email: string;
}

export const InvalidTokenForm: React.FC<Props> = ({
  setFormType,
  tokenType,
  email,
}: Props) => {
  const [isSent, setIsSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onRestorePassword = async () => {
    setIsSubmitting(true);
    const response = await api.postClientRestorePassword({
      email,
    });
    setIsSubmitting(false);
    const { success } = response;
    if (success) setIsSent(true);
  };

  return (
    <>
      {!isSent ? (
        <>
          <Title>
            {tokenType === TokenType.ConfirmationToken
              ? i18n.t('invalidTokenForm.emailType.title', {
                  ns: 'auth',
                })
              : i18n.t('invalidTokenForm.passwordType.title', {
                  ns: 'auth',
                })}
          </Title>
          <Content className={styles.content}>
            {email ? (
              <ButtonWithLoader
                className={styles.buttonWithLoader}
                isLoading={isSubmitting}
                onClick={onRestorePassword}
              >
                {i18n.t('invalidTokenForm.emailType.buttonSent', {
                  ns: 'auth',
                })}
              </ButtonWithLoader>
            ) : (
              <ButtonWithLoader
                className={styles.buttonWithLoader}
                isLoading={isSubmitting}
                onClick={() => {
                  setFormType(AuthFormType.Login);
                }}
              >
                {i18n.t('invalidTokenForm.passwordType.buttonSent', {
                  ns: 'auth',
                })}
              </ButtonWithLoader>
            )}
          </Content>
        </>
      ) : (
        <>
          <Title>
            {i18n.t('invalidTokenForm.sentType.title', {
              ns: 'auth',
            })}
          </Title>
          <Content>
            <EmailButton email={email} />
          </Content>
        </>
      )}
    </>
  );
};
